import script from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./VideoPlayer.vue?vue&type=style&index=0&id=42a62cc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a62cc0"]])

export default __exports__